module.exports = __webpack_public_path__ + "static/media/logout.59a0a1fb.svg";